import { graphql } from 'generated/gql/account-manager';
import { useAuthorizationHeader } from 'graphql/helpers';
import { useAmQuery } from 'graphql/useAmQuery';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useEffect } from 'react';
import { useScript } from './ThirdPartyScriptLoader/useScript';

const hubpotIdentificationTokenQueryDocument = graphql(`
  query hubspotToken {
    hubspotToken
  }
`);

export function useHubSpot(hubSpotId: string) {
  useScript({
    // NOTE: this ID may be needed by the script
    id: 'hs-script-loader',
    src: `//js-na2.hs-scripts.com/${hubSpotId}.js`,
    async: true,
    defer: true,
  });

  useHubSpotMessengerSettings();
}

// See https://developers.hubspot.com/docs/api-reference/conversations-visitor-identification-v3/guide#example-integration-flow
function useHubSpotMessengerSettings() {
  const { data } = useCurrentUser();
  const requestHeaders = useAuthorizationHeader();
  const hubspotTokenQuery = useAmQuery(
    hubpotIdentificationTokenQueryDocument,
    {},
    // Don't run until the user is authenticated
    { enabled: !!requestHeaders }
  );

  useEffect(() => {
    // Delay loading the messenger while the user data and token are loading
    window.hsConversationsSettings = {
      loadImmediately: false,
    };

    if (!data?.user || !hubspotTokenQuery.data?.hubspotToken) {
      return;
    }

    // Add the user data and token to the messenger settings
    window.hsConversationsSettings = {
      loadImmediately: false,
      identificationEmail: data.user.email,
      identificationToken: hubspotTokenQuery.data.hubspotToken,
    };

    // Load the messenger
    window.HubSpotConversations?.widget.load();
  }, [data?.user, hubspotTokenQuery.data?.hubspotToken]);
}
